import React from 'react';
import Section from '../../../shared/Section/Section';

export default function PaymentAndGroups({ bg, children }) {
  return (
    <Section theme="lightPurple" bg={bg} position={'bottom'}>
      {children}
    </Section>
  );
}
